/**
 * Bundle Picks — see comments in sections/product-bundle.liquid for overview.
 * Phase 7: Countdown Timer + Volume Discount Tiers + Post-Add Upsell Panel
 * v3: register custom element to prevent :not(:defined) hiding + display:block guarantee
 */
if (!customElements.get('product-bundle')) {
  customElements.define('product-bundle', class extends HTMLElement {
    connectedCallback() { this.style.display = 'block'; }
  });
}

(function () {
  var lastRelocated = null;

  // ── helpers ────────────────────────────────────────────────────────────────

  function relocate(bundleEl) {
    var designMode = window.Shopify && window.Shopify.designMode;
    var selector = bundleEl.getAttribute('data-relocate-after');
    if (!selector) { bundleEl.setAttribute('data-relocated', 'true'); return; }
    var anchor = lastRelocated || document.querySelector(selector);
    var originalWrapper = bundleEl.closest('.shopify-section');
    if (anchor && anchor.parentElement) {
      anchor.insertAdjacentElement('afterend', bundleEl);
      lastRelocated = bundleEl;
      if (!designMode && originalWrapper) originalWrapper.style.display = 'none';
    }
    bundleEl.setAttribute('data-relocated', 'true');
    bundleEl.style.visibility = 'visible';
  }

  function formatMoney(cents, currencyCode) {
    var value = cents / 100;
    if (currencyCode) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(value); }
      catch (e) {}
    }
    return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getRowPriceCents(row) {
    var select = row.querySelector('[data-bundle-variant-select]');
    if (select) {
      var opt = select.options[select.selectedIndex];
      if (opt && opt.getAttribute('data-price-cents')) return parseInt(opt.getAttribute('data-price-cents'), 10) || 0;
    }
    return parseInt(row.getAttribute('data-price-cents'), 10) || 0;
  }

  function getRowVariantId(row) {
    var select = row.querySelector('[data-bundle-variant-select]');
    if (select) return select.value;
    return row.getAttribute('data-variant-id');
  }

  function isRowChecked(row) {
    if (row.getAttribute('data-bundle-locked') === 'true') return true;
    var checkbox = row.querySelector('[data-bundle-checkbox]');
    return checkbox ? checkbox.checked : true;
  }

  // ── countdown timer ────────────────────────────────────────────────────────

  function setupCountdown(bundleEl) {
    var timerEl = bundleEl.querySelector('[data-bundle-timer]');
    if (!timerEl) return;
    var minutes = parseInt(bundleEl.getAttribute('data-countdown-minutes'), 10) || 30;
    var sectionId = bundleEl.getAttribute('data-section-id') || 'default';
    var storageKey = 'hg-bundle-timer-' + sectionId;
    var now = Date.now();
    var endMs;
    try {
      var stored = sessionStorage.getItem(storageKey);
      if (stored) {
        endMs = parseInt(stored, 10);
        if (endMs <= now) endMs = null;
      }
    } catch (e) {}
    if (!endMs) {
      endMs = now + minutes * 60 * 1000;
      try { sessionStorage.setItem(storageKey, String(endMs)); } catch (e) {}
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }
    var display = timerEl.querySelector('[data-timer-display]');
    if (bundleEl._countdownTid) clearTimeout(bundleEl._countdownTid);
    var tid;
    function tick() {
      var remaining = endMs - Date.now();
      if (remaining <= 0) {
        if (display) display.textContent = '00:00:00';
        return;
      }
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      if (display) display.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      bundleEl._countdownTid = tid = setTimeout(tick, 1000);
    }
    tick();
  }

  // ── volume discount tiers ──────────────────────────────────────────────────

  function setupVolumeTiers(bundleEl, rows) {
    var tiersEl = bundleEl.querySelector('[data-bundle-tiers]');
    if (!tiersEl) return null;
    var tier2Discount = parseFloat(bundleEl.getAttribute('data-tier2-discount')) || 0;
    var tier3Discount = parseFloat(bundleEl.getAttribute('data-tier3-discount')) || 0;

    function getActiveTierDiscount() {
      var checkedCount = rows.filter(isRowChecked).length;
      var activeTier = 0;
      var activeDiscount = 0;
      if (tier3Discount > 0 && checkedCount >= 3) { activeTier = 3; activeDiscount = tier3Discount; }
      else if (tier2Discount > 0 && checkedCount >= 2) { activeTier = 2; activeDiscount = tier2Discount; }

      tiersEl.querySelectorAll('[data-tier]').forEach(function (pill) {
        var tierVal = parseInt(pill.getAttribute('data-tier'), 10);
        pill.classList.toggle('product-bundle__tier--active', activeTier > 0 && tierVal === activeTier);
      });
      return activeDiscount;
    }
    return getActiveTierDiscount;
  }

  // ── upsell panel ───────────────────────────────────────────────────────────

  function setupUpsell(bundleEl) {
    var upsellEl = bundleEl.querySelector('[data-bundle-upsell]');
    if (!upsellEl) return null;

    upsellEl.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        var origText = btn.textContent;
        btn.textContent = '...';
        var cartNotification = getCartNotification();
        var body = { items: [{ id: variantId, quantity: 1 }] };
        if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
          body.sections = cartNotification.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          body.sections_url = window.location.pathname;
          if (typeof cartNotification.setActiveElement === 'function') cartNotification.setActiveElement(document.activeElement);
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            btn.textContent = 'Added ✓';
            btn.style.background = '#0f7a3d';
            if (cartNotification && response.sections && response.items && response.items.length) {
              renderCartNotification(cartNotification, response);
            } else {
              refreshCartBubble();
            }
          })
          .catch(function () {
            btn.textContent = origText;
            btn.disabled = false;
            showToast(bundleEl, 'Could not add item to cart.');
          });
      });
    });

    return function revealUpsell() {
      upsellEl.hidden = false;
      upsellEl.classList.add('product-bundle__upsell--visible');
    };
  }

  // ── totals ─────────────────────────────────────────────────────────────────

  function setupTotals(bundleEl, getActiveTierDiscount) {
    var rows = Array.prototype.slice.call(bundleEl.querySelectorAll('[data-bundle-row]'));
    var baseDpct = parseFloat(bundleEl.getAttribute('data-discount-percent')) || 0;
    var fixedPriceCents = parseInt(bundleEl.getAttribute('data-fixed-price-cents'), 10) || 0;
    var currencyCode = bundleEl.getAttribute('data-currency-code') || '';
    var originalEl = bundleEl.querySelector('[data-bundle-total-original]');
    var finalEl = bundleEl.querySelector('[data-bundle-total-final]');
    var savingsEl = bundleEl.querySelector('[data-bundle-savings-note]');
    var addAllBtn = bundleEl.querySelector('[data-bundle-add-all]');

    function update() {
      var checkedRows = rows.filter(isRowChecked);
      var subtotalCents = checkedRows.reduce(function (sum, row) { return sum + getRowPriceCents(row); }, 0);

      rows.forEach(function (row) {
        if (isRowChecked(row)) row.removeAttribute('data-bundle-row-unchecked');
        else row.setAttribute('data-bundle-row-unchecked', 'true');
      });

      var tierDiscount = getActiveTierDiscount ? getActiveTierDiscount() : 0;
      var effectiveDiscount = tierDiscount > 0 ? tierDiscount : baseDpct;

      var allChecked = checkedRows.length === rows.length;
      var useFixedPrice = fixedPriceCents > 0 && allChecked;
      var applyDiscount = !useFixedPrice && effectiveDiscount > 0 && checkedRows.length > 1;
      var finalCents = useFixedPrice ? fixedPriceCents
        : applyDiscount ? Math.round(subtotalCents * (1 - effectiveDiscount / 100))
        : subtotalCents;

      if (finalEl) finalEl.textContent = formatMoney(finalCents, currencyCode);
      var showCompare = finalCents < subtotalCents;
      if (originalEl) {
        if (showCompare) { originalEl.textContent = formatMoney(subtotalCents, currencyCode); originalEl.hidden = false; }
        else originalEl.hidden = true;
      }
      if (savingsEl) {
        if (showCompare) {
          var savedCents = subtotalCents - finalCents;
          var discountLabel = useFixedPrice ? 'Bundle price'
            : tierDiscount > 0 ? tierDiscount + '% volume discount'
            : effectiveDiscount + '% bundle discount';
          savingsEl.textContent = discountLabel + ' — you save ' + formatMoney(savedCents, currencyCode) + '.';
          savingsEl.hidden = false;
        } else savingsEl.hidden = true;
      }
      if (addAllBtn) addAllBtn.disabled = checkedRows.length === 0;
    }

    rows.forEach(function (row) {
      var checkbox = row.querySelector('[data-bundle-checkbox]');
      if (checkbox) checkbox.addEventListener('change', update);
      var select = row.querySelector('[data-bundle-variant-select]');
      if (select) select.addEventListener('change', update);
    });
    update();
    return { rows: rows, update: update };
  }

  function refreshCartBubble() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    }).catch(function () {});
  }

  function showToast(bundleEl, message) {
    var toast = bundleEl.querySelector('[data-bundle-toast]');
    if (!toast) return;
    toast.textContent = message; toast.hidden = false;
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () { toast.hidden = true; }, 2500);
  }

  function getCartNotification() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function renderCartNotification(cartNotification, response) {
    var keys = response.items.map(function (item) { return item.key; });
    var sections = response.sections || {};
    var productHtml = sections['cart-notification-product'];
    var productContainer = document.getElementById('cart-notification-product');
    if (productHtml && productContainer) {
      var doc = new DOMParser().parseFromString(productHtml, 'text/html');
      var rows = keys.map(function (key) { return doc.querySelector('[id="cart-notification-product-' + key + '"]'); }).filter(Boolean);
      if (rows.length) { productContainer.innerHTML = ''; rows.forEach(function (row) { productContainer.appendChild(row.cloneNode(true)); }); }
    }
    ['cart-notification-button', 'cart-icon-bubble'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && sections[id] && typeof cartNotification.getSectionInnerHTML === 'function')
        el.innerHTML = cartNotification.getSectionInnerHTML(sections[id], '.shopify-section');
    });
    cartNotification.cartItemKey = keys[keys.length - 1];
    if (cartNotification.header) cartNotification.header.reveal();
    if (typeof cartNotification.open === 'function') cartNotification.open();
  }

  function setupAddAll(bundleEl, totals, revealUpsell) {
    var button = bundleEl.querySelector('[data-bundle-add-all]');
    if (!button) return;
    var label = button.querySelector('[data-bundle-add-all-label]');
    var spinner = button.querySelector('.loading__spinner');
    var originalText = label ? label.textContent : '';

    button.addEventListener('click', function () {
      if (button.disabled || button.classList.contains('loading')) return;
      var checkedRows = totals.rows.filter(isRowChecked);
      if (checkedRows.length === 0) return;
      var items = checkedRows.map(function (row) {
        var variantId = getRowVariantId(row);
        return variantId ? { id: variantId, quantity: 1 } : null;
      }).filter(Boolean);
      if (items.length === 0) return;

      button.disabled = true;
      button.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      var cartNotification = getCartNotification();
      var body = { items: items };
      if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
        body.sections = cartNotification.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        body.sections_url = window.location.pathname;
        if (typeof cartNotification.setActiveElement === 'function') cartNotification.setActiveElement(document.activeElement);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (err) { throw new Error((err && err.description) || 'Could not add bundle to cart'); });
          return response.json();
        })
        .then(function (response) {
          if (label) label.textContent = 'Added';
          if (cartNotification && response.sections && response.items && response.items.length) {
            renderCartNotification(cartNotification, response);
          } else {
            refreshCartBubble();
            showToast(bundleEl, 'Bundle added to your cart.');
          }
          if (revealUpsell) setTimeout(revealUpsell, 500);
          setTimeout(function () { if (label) label.textContent = originalText; button.disabled = false; }, 1500);
        })
        .catch(function (err) {
          if (label) label.textContent = originalText;
          button.disabled = false;
          showToast(bundleEl, err.message || 'Could not add bundle to cart.');
        })
        .finally(function () { button.classList.remove('loading'); if (spinner) spinner.classList.add('hidden'); });
    });
  }

  function setupMainVariantSync(bundleEl, update) {
    var mainRow = bundleEl.querySelector('[data-bundle-main]');
    if (!mainRow) return;
    var priceMap;
    try { priceMap = JSON.parse(mainRow.getAttribute('data-variant-prices') || '{}'); }
    catch (e) { priceMap = {}; }
    var scope = document.querySelector('.product__info-container') || document;
    var idInput = scope.querySelector('[name="id"]');
    if (!idInput) return;
    function sync() {
      var id = idInput.value;
      if (!id) return;
      mainRow.setAttribute('data-variant-id', id);
      if (priceMap[id] != null) mainRow.setAttribute('data-price-cents', priceMap[id]);
      update();
    }
    scope.addEventListener('change', function () { setTimeout(sync, 0); });
    sync();
  }

  function initBundle(bundleEl) {
    if (bundleEl.getAttribute('data-relocate-after')) bundleEl.style.visibility = 'hidden';
    relocate(bundleEl);
    setupCountdown(bundleEl);
    var rows = Array.prototype.slice.call(bundleEl.querySelectorAll('[data-bundle-row]'));
    var getActiveTierDiscount = setupVolumeTiers(bundleEl, rows);
    var totals = setupTotals(bundleEl, getActiveTierDiscount);
    var revealUpsell = setupUpsell(bundleEl);
    setupAddAll(bundleEl, totals, revealUpsell);
    setupMainVariantSync(bundleEl, totals.update);
  }

  function init() {
    document.querySelectorAll('product-bundle').forEach(function (bundleEl) {
      try { initBundle(bundleEl); } catch (e) {
        bundleEl.setAttribute('data-relocated', 'true');
        bundleEl.style.visibility = 'visible';
        if (window.console && console.error) console.error('[bundle] init failed', e);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    lastRelocated = null;
    var sectionEl = e.target;
    if (sectionEl && sectionEl.id) {
      var sectionId = sectionEl.id.replace('shopify-section-', '');
      document.querySelectorAll('product-bundle[data-section-id="' + sectionId + '"][data-relocated]').forEach(function (el) {
        if (!sectionEl.contains(el)) el.remove();
      });
    }
    var root = (sectionEl && sectionEl.querySelector) ? sectionEl : document;
    root.querySelectorAll('product-bundle:not([data-relocated])').forEach(function (bundleEl) {
      try { initBundle(bundleEl); }
      catch (err) { bundleEl.setAttribute('data-relocated', 'true'); bundleEl.style.visibility = 'visible'; }
    });
  });
})();
